
(function($){
  var that = {};
  var user_lib = that; // compat
  that.currentBubbleCount = 0;

  that.setUser = function (user) {
    if (typeof user !== "undefined") {
      var expire = 0.02;
      user.created = new Date().getTime();
      user.expire = expire;
      user.expire_seconds = parseInt(expire * 86400000);
      $.cookie('user', JSON.stringify(user), {expires: 0.02, path: "/"});
    }
  };

  that.getUser = function () {
    if (!$.cookie("user")) {
      var xhr = $.ajax({
        url: "/ajax.php?blog_id=" + sage_js.blog_id + "&action=ajax_general&template=get_current_user",
        dataType: "JSON"
      });
      xhr.always(function (data) {
        var user = data.data.user;
        if (data.status === "success") {
          that.setUser(user);
        }
      });
      return false;
    }
    return JSON.parse($.cookie('user'));
  };

  that.refreshUser = function () {
    $.removeCookie("user");
    that.getUser();
    setInterval(function () {
      $.removeCookie("user");
      that.getUser();
    }, 1600000);
  };

  that.getInitials = function (display_name) {

    // bvr change
    display_name = wp.hooks.applyFilters( 'userGetInitials', display_name );
    getLibObject("helper").log("triggered userGetInitials: " + display_name );

    var splitted = display_name.split(" ");
    var initials = "";
    var initials_array = [];
    if (splitted.length) {
      for (var i = 0; i < splitted.length; i++) {
        initials_array.push(splitted[i].charAt(0));
      }
      if (initials_array.length === 1) {
        initials = initials_array[0];
      }
      if (initials_array.length > 1) {
        initials = initials_array[0] + "" + initials_array[initials_array.length - 1];
      }
    }
    return initials;
  };

  that.bubbleCommentUpdateDom = function(comment) {
    var commentEl = $("a[data-comment-id=" + comment.comment_ID + "]");

    // comment exists
    if(commentEl.length) {
      var parent = commentEl.parent();
      commentEl.attr("data-votecount",comment.comment_karma);
      commentEl.addClass("vote-updated");
      if(comment.comment_content !== '') {
        commentEl.find('.message').html(getLibObject('helper').wpautop(getLibObject('comments').replaceSmileys(comment.comment_content)));
      }
      that.currentUserComments[comment.comment_ID] = comment;

      that.initCommentBubbleScreen(parent);
    }
  };

  that.insertCommentBubble = function(comment, template, parent){
    if(!comment.comment_initials) {
      comment.comment_initials = that.getInitials(comment.comment_author);
    }
    comment = that.addCommentMetaData(comment);
    var singleZuschauer = template;
    singleZuschauer = singleZuschauer
      .replaceAll("%%USERID%%", comment.user_id)
      .replaceAll("%%POPUPID%%", "popup-" + comment.user_id + "-" + comment.comment_ID )
      .replaceAll("%%COMMENTID%%", comment.comment_ID)
      .replaceAll("%%VOTECOUNT%%", comment.comment_karma)
      .replaceAll("%%USERINITIALS%%", comment.comment_initials)
      .replaceAll("%%USERNAME%%", comment.comment_author + " fragt:")
      .replaceAll("%%COMMENTTIME%%", comment.timestamp_formated)
      .replaceAll("%%COMMENTMESSAGE%%", getLibObject('comments').replaceSmileys(comment.comment_content.replace(/<[^>]*>?/gm, '')))
      .replaceAll("%%CLASS%%", "new-element");

    parent.append(singleZuschauer);
    if(that.currentBubbleCount >= 50) {
      var lowest = Object.values(that.currentUserComments).reduce(function(prev, curr){
        return prev.timestamp_unix < curr.timestamp_unix ? prev : curr;
      });
      var force = true;
      that.deleteCommentBubble(parent, lowest, force);
    }
    that.currentUserComments[comment.comment_ID] = comment;
    that.currentBubbleCount++;

    that.initCommentBubbleScreen(parent);
  };

  that.insertOrUpdateCommentBubble = function(comment, template, parent){

    var userBubble = parent
      .find("[data-user-id=" + comment.user_id + "]")
      .filter("[data-comment-id=" + comment.comment_ID + "]");

    if(!userBubble.length) {
      // create user bubble for this comment
      that.insertCommentBubble(comment, template, parent);
    } else {
      that.bubbleCommentUpdateDom(comment);
    }
  };

  that.insertUserBubbleIfNotExists = function(parent, template, user){
    var userBubble = parent
      .find("[data-user-id=" + user.ID + "]");

    if(!userBubble.length) {
      // create user bubble for this comment
      var userBubbleHtml = template;
      userBubbleHtml = userBubbleHtml
        .replaceAll("%%USERID%%", user.ID)
        .replaceAll('data-comment-id="%%COMMENTID%%', "")
        .replaceAll('data-votecount="%%VOTECOUNT%%"', "")
        .replaceAll("%%POPUPID%%", "popup-" + user.ID + "-x" )
        .replaceAll("%%USERINITIALS%%", getLibObject('helper').getInitials(user.display_name))
        .replaceAll("%%USERNAME%%", "")
        .replaceAll("%%COMMENTTIME%%", "")
        .replaceAll("%%COMMENTMESSAGE%%", "")
        .replaceAll("%%CLASS%%", "new-element");

      parent.append(userBubbleHtml);
    }
  };

  that.addCommentMetaData = function(comment){
    var date = new Date(comment.comment_date);
    comment.comment_initials = getLibObject('helper').getInitials(comment.comment_author);
    comment.timestamp_formated = getLibObject('helper').getDateTimestampFormated(date);
    comment.timestamp_iso = getLibObject('helper').getDateTimestampIso(date);
    comment.timestamp_unix = getLibObject('helper').getDateTimestampUnix(date);
    if(!comment.meta) {
      comment.meta = {};
    }
    return comment;
  };

  that.deleteCommentBubble = function(parent, comment, force){
    force = force || false;
    if(!getLibObject('comments').modCommentFilter(comment) || force) {
      // instead of old approach we just delete stuff on remove event
      parent.find("[data-comment-id=" + comment.comment_ID + "]").remove();
      delete that.currentUserComments[comment.comment_ID];
      that.currentBubbleCount--;
    }
  };

  that.highlightCommentBubble = function(parent, commentId){
    // todo: do stuff (open lightbox?)
    parent.find("[data-comment-id=" + commentId + "]");
  };

  that.initCommentBubbleScreen = function(bubbleContainer) {
    // init bubbles
    //if(!getLibObject("dots").DotsUserQuestions.isInit) {
    bubbleContainer.on('click',".bubble",function(e){ // should also work for new bubbles this way
      e.preventDefault();
      if($(this).attr("data-comment-id")) {
        $.fancybox.open([
          {href: $(this).attr("href")}
        ],{
          wrapCSS: "user-fragen",
          minWidth: 600,
          minHeight: 200,
          maxWidth: "80%",
          maxHeight: "80%",
          arrows: false,
          closeBtn: false,
          helpers : {
            overlay : {
              css : {
                'background' : 'transparent'
              }
            }
          },
          padding: ["25px","30px","25px","30px"]
        });
      }
    });
    getLibObject("dots").DotsUserQuestions.init('.bubble-container', '.bubble', {});
    getLibObject("dots").DotsUserQuestions.start();
    getLibObject("dots").DotsUserQuestions.isInit = true;
    bubbleContainer.find(".new-element").removeClass("new-element");
    bubbleContainer.find(".vote-updated").removeClass("vote-updated");
    //}
  };

  that.updateCommentBubbleScreen = function(bubbleContainer) {
    // update Bubbles
    var new_elements = bubbleContainer.find(".new-element");
    var updated_elements = bubbleContainer.find(".vote-updated");
    var all_voted_elements = bubbleContainer.find("[data-votecount]");

    getLibObject("dots").DotsUserQuestions.updateCache();
    if(updated_elements.length || deleted_comments || new_elements.length) {
      getLibObject("dots").DotsUserQuestions.update(all_voted_elements); // first change size
    }
    if(new_elements.length) {
      getLibObject("dots").DotsUserQuestions.add(new_elements); // then add new
    }
    new_elements.removeClass("new-element");
    updated_elements.removeClass("vote-updated");
  };

  that.initUserQuestions = function(){
    var bubbleContainer = $("#zuschauer-bubbles").find(".bubble-container");
    var singleZuschauer;
    var deletedDomments = false;

    // comment fields:
    /*
      comments[k].comment_ID,
      comments[k].user_id,
      comments[k].timestamp_unix,
      comments[k].comment_initials,
      comments[k].comment_author,
      comments[k].comment_karma,
      comments[k].timestamp_iso,
      comments[k].timestamp_formated,
      comments[k].comment_content,
      comments[k].comment_vimeo_timestamp
    */

    var limit = getLibObject('config').bubbleLimit;

    // handle comments
    if(that.currentUserComments) {
      var commentArray = getLibObject("helper").shuffleArray(
        Object
          .values(that.currentUserComments)
          .filter(getLibObject('comments').modCommentFilter)
      );

      $.each(commentArray,function(index, comment) {
        comment = that.addCommentMetaData(comment);
        that.currentUserComments[comment.comment_ID] = comment;

        that.insertOrUpdateCommentBubble(comment,
          getLibObject('config').ajax_templates.zuschauerComment, bubbleContainer);
      });
    }

    // handle users
    if(that.currentUsers) {
      var userArray = Object.values(that.currentUsers);
      /*
      // to simulate more users for dev:
      if(getLibObject("config").simulateZuschauerBubbles) {
          for (var i = 0; i < 6; i++) {
              zuschauer.zuschauer = zuschauer.zuschauer.concat(JSON.parse(JSON.stringify(zuschauer.zuschauer)));
          }
      }
      */

      // add zuschauer bubbles if they have no comment
      $.each(userArray, function (index, user) {
        if(that.currentBubbleCount <= limit) {
          that.insertUserBubbleIfNotExists(bubbleContainer,
            getLibObject('config').ajax_templates.zuschauerComment, user);
          that.currentBubbleCount++;
        }
      });
    }

    that.initCommentBubbleScreen(bubbleContainer);
  };

  that.insertThementagUserBubble = function(user){
    var userID = user.ID;
    var roleClass = user.roleClass;
    var displayName = user.display_name;
    var template = getLibObject('config').ajax_templates.zuschauer;
    var counter = $('.user-counter .counter');
    var parent = $('.bubble-container');
    var childrenCount = parent.children().length;

    if(childrenCount < 150) {
      if(parent.find('li[data-user-id="'+userID+'"]').length === 0) {
        var newBubble = template
          .replaceAll("%%USERID%%", userID)
          .replaceAll("%%ROLECLASS%%", roleClass)
          .replaceAll("%%USERINITIALS%%", that.getInitials(displayName));

        parent.append(newBubble);


        getLibObject("dots").DotsReplacementEliptic.init('.bubble-container', '.bubble', {});
        getLibObject("dots").DotsReplacementEliptic.start();
      }
    }
    var userLib = getLibObject('user');
    if( userLib.currentUserIds && userLib.currentUserIds.indexOf(userID) === -1) {
      userLib.currentUserIds.push(userID);
      counter.html(userLib.currentUserIds.length);
      if(childrenCount > 1) {
        $('.user-counter.single').addClass('hide');
        $('.user-counter.multi').removeClass('hide');
      } else {
        $('.user-counter.single').removeClass('hide');
        $('.user-counter.multi').addClass('hide');
      }
    }
  };

  window.vrnetworld.user = that;
})(jQuery);
